import styled from 'styled-components';
import Carousel1 from '../../../../common/Carousel1';
import Banner1 from '../Banner1';
import { BannerDetails } from '../../../../../pages/mutualFunds';
import { useDeviceType } from '../../../../../utils/deviceType';
import DEVICE_TYPE from '../../../../../constants/device';
import { isBannerActive } from '../../../../../utils/common';
import GTM from '../../../../../GTM';

export interface ImageDetails {
  id: string;
  src: string;
  alt: string;
  link: string;
}
interface CarouselProps {
  imageDetails: Array<BannerDetails>;
  desktopSlidesToShow?: number;
  enableAutoPlay?: boolean;
  infiniteScroll?: boolean;
  shouldShowDots?: boolean;
  onBannerClick: Function;
}

const CarouselWrapper = styled.div`
  height: 100%;
  overflow: hidden;
`;

export default function Carousel(props: CarouselProps) {
  const { imageDetails, desktopSlidesToShow, enableAutoPlay, infiniteScroll, shouldShowDots, onBannerClick } = props;
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  return (
    <CarouselWrapper>
      <Carousel1
        id={isMobile ? 'mobile' : 'desktop'}
        device={isMobile ? 'mobile' : 'desktop'}
        desktopSlidesToShow={!isMobile && desktopSlidesToShow}
        enableAutoPlay={enableAutoPlay}
        infiniteScroll={infiniteScroll}
        shouldShowDots={shouldShowDots}
        shouldShowArrow={!isMobile}
      >
        {imageDetails
          .filter((banner) => isBannerActive(banner.startDate, banner.endDate))
          .map((bannerDetails, index) => (
            <Banner1
              src={bannerDetails.imageURL}
              alt={bannerDetails.imageDescription}
              key={`banner-details-${index}`}
              onClick={(event) => {
                GTM.banner.onClickBanner(bannerDetails.imageDescription)
                onBannerClick(bannerDetails.actionType, bannerDetails.screen, index, bannerDetails.imageDescription);
              }}
            />
          ))}
      </Carousel1>
    </CarouselWrapper>
  );
}
